import { ComponentProps } from "react";
import { Trans as I18nextTrans, useTranslation } from "react-i18next";

export function T(props: ComponentProps<typeof I18nextTrans>) {
  useTranslation();
  return <I18nextTrans {...props} />;
}
